import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription,
  AlertDialogFooter, AlertDialogCancel, AlertDialogAction,
} from "@/components/ui/alert-dialog";

const REASON = { not_for_me: "not for you", too_expensive: "too pricey", too_difficult: "too hard" };

export const HideConfirm = ({ pending, swapsLeft, onCancel, onConfirm }) => {
  const free = swapsLeft != null;
  const out = free && swapsLeft <= 0;
  return (
    <AlertDialog open={!!pending} onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent className="bg-[#14161B] border-[#2A2E39] text-white" data-testid="hide-confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{out ? "You've used your 2 free swaps" : "Are you sure?"}</AlertDialogTitle>
          <AlertDialogDescription className="text-gray-300">
            {out
              ? "Upgrade to Pro to see every path. You can still bring back hidden paths with Show hidden paths."
              : <>Hide <b>{pending?.title}</b> because it's {REASON[pending?.action]}? The next best path takes its place, and you can bring it back with Show hidden paths.
                {free && <span className="block mt-2" data-testid="hide-swaps-left">Free plan: this uses 1 of your swaps ({swapsLeft} left).</span>}</>}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="bg-transparent border-[#2A2E39] text-white" data-testid="hide-cancel">Keep it</AlertDialogCancel>
          {out
            ? <AlertDialogAction asChild><Link to="/pro" className="hero-accent text-white" data-testid="hide-upgrade">Upgrade to Pro</Link></AlertDialogAction>
            : <AlertDialogAction onClick={onConfirm} className="hero-accent text-white" data-testid="hide-confirm">Yes, hide it</AlertDialogAction>}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export const HiddenPaths = ({ count, onChange }) => {
  const [open, setOpen] = useState(false);
  const [list, setList] = useState([]);
  useEffect(() => { if (open) api.get("/feedback/hidden").then(r => setList(r.data.hidden)).catch(() => {}); }, [open]);
  if (!count) return null;
  const restore = async (id) => {
    await api.delete(`/feedback/hidden/${id}`);
    setList(l => l.filter(x => x.id !== id));
    toast.success("Path is back in your list.");
    onChange?.();
  };
  return (
    <div className="mt-4" data-testid="hidden-paths">
      <button onClick={() => setOpen(o => !o)} className="text-sm text-gray-300 underline hover:text-white" data-testid="show-hidden-paths">
        {open ? "Close hidden paths" : `Show hidden paths (${count})`}
      </button>
      {open && (
        <div className="mt-3 space-y-2">
          {list.map(h => (
            <div key={h.id} className="flex items-center justify-between gap-3 card-panel px-4 py-3" data-testid={`hidden-${h.id}`}>
              <span className="text-sm text-gray-200">{h.title}</span>
              <button onClick={() => restore(h.id)} className="text-xs border border-[#2A2E39] hover:border-white px-3 py-1.5 rounded" data-testid={`unhide-${h.id}`}>Bring back</button>
            </div>
          ))}
          <p className="text-xs text-gray-500">Bringing a path back doesn't give a swap back.</p>
        </div>
      )}
    </div>
  );
};
